import Footer from './Components/Footer';
import Navbar from './Components/Navbar';
import AllRoutes from './Routing/AllRoutes';
import './App.css'
function App() {
  return (
    <>
      <Navbar />
      <AllRoutes />
      <br />
      <br />
      <Footer />
    </>
  );
}

export default App;
